export const BYTES_PER_KB = 1024;
export const KB_PER_MB = 1024;
export const MB_LIMIT = 50;
export const MAX_FILE_SIZE = MB_LIMIT * KB_PER_MB * BYTES_PER_KB;
export const MAX_FILES = 10;

export const ALLOWED_FILE_TYPES = [
	"image/*",
	"video/*",
	"audio/*",
	"application/pdf",
	"application/msword",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/vnd.ms-excel",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	"application/vnd.ms-powerpoint",
	"application/vnd.openxmlformats-officedocument.presentationml.presentation",
	"text/plain",
	"text/csv",
	"application/zip",
	"application/x-rar-compressed",
] as const;
